/* tslint:disable */
/* eslint-disable */
/**
 * Sellsen API
 * Ürün Tarama ve SP-API Entegrasyonu
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * @export
 */
export const StorefrontScanUpdateDTOStatusEnum = {
    Pending: 'PENDING',
    Inprogress: 'INPROGRESS',
    Completed: 'COMPLETED',
    Failed: 'FAILED',
    Suspended: 'SUSPENDED',
    Exported: 'EXPORTED',
    Unavaliable: 'UNAVALIABLE',
    WaitingResults: 'WAITING_RESULTS'
};
/**
 * @export
 */
export const StorefrontScanUpdateDTOTagEnum = {
    Control: 'CONTROL',
    Closed: 'CLOSED',
    Forbidden: 'FORBIDDEN'
};
/**
 * @export
 */
export const StorefrontScanUpdateDTOLocationEnum = {
    UnitedStates: 'UNITED_STATES',
    Brazil: 'BRAZIL',
    Canada: 'CANADA',
    Mexico: 'MEXICO',
    Australia: 'AUSTRALIA',
    Japan: 'JAPAN',
    India: 'INDIA',
    Singapore: 'SINGAPORE',
    Germany: 'GERMANY',
    Spain: 'SPAIN',
    France: 'FRANCE',
    Italy: 'ITALY',
    Netherlands: 'NETHERLANDS',
    Belgium: 'BELGIUM',
    Poland: 'POLAND',
    Sweden: 'SWEDEN',
    UnitedKingdom: 'UNITED_KINGDOM',
    Ireland: 'IRELAND',
    UnitedArabEmirates: 'UNITED_ARAB_EMIRATES',
    Egypt: 'EGYPT',
    SaudiArabia: 'SAUDI_ARABIA',
    All: 'ALL'
};
/**
 * Check if a given object implements the StorefrontScanUpdateDTO interface.
 */
export function instanceOfStorefrontScanUpdateDTO(value) {
    return true;
}
export function StorefrontScanUpdateDTOFromJSON(json) {
    return StorefrontScanUpdateDTOFromJSONTyped(json, false);
}
export function StorefrontScanUpdateDTOFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'status': json['status'] == null ? undefined : json['status'],
        'tag': json['tag'] == null ? undefined : json['tag'],
        'location': json['location'] == null ? undefined : json['location'],
    };
}
export function StorefrontScanUpdateDTOToJSON(json) {
    return StorefrontScanUpdateDTOToJSONTyped(json, false);
}
export function StorefrontScanUpdateDTOToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'status': value['status'],
        'tag': value['tag'],
        'location': value['location'],
    };
}
